import { getSafeValue } from "../../../util/json";
import API from "../../api";

const getReferralInfo = (user) => {
    return new API(user).getRequest('/getReferralInfo').then(json => {
        return getSafeValue(json, "referralLink", "string");
    });
}

export default getReferralInfo;